// Pooled inbox SP4, decision 29 (variant A): a client must choose a plan and
// add a card before the advisors' thread is offered. SP5: the server enforces
// it (402 plan_required, spec § The chat gate); this helper only decides what
// the rail and the header offer, from the server's Entitlement — the verified
// user's `entitlement.chat` — and never from `payment_status`.
export const hasChatAccess = (user) => user?.entitlement?.chat === true;

// SP5: "Choose a plan" is the dark plan page (spec § Removals: the SP4 seam's
// /package goes).
export const CHOOSE_PLAN_PATH = "/plan";
